import { Content } from '../../types';

export const phuQuocIslandContent: Content = {
  title: 'פוקוק - פנינת הדרום של וייטנאם',
  imageUrl: '/images/vietnam/phu-quoc/phu_quac_preview.jpeg',
  introduction:
    'האי פוקוק (Phú Quốc), הינו האי הגדול ביותר בוייטנאם וממוקם במפרץ תאילנד, סמוך לחופי קמבודיה. הוא נחשב ליעד תיירותי מוביל בזכות חופי הים הלבנים שלו, היערות הטרופיים, התרבות הייחודית והאפשרויות הרבות לבילוי ונופש. פוקוק, מכונה לעיתים "גן עדן טרופי" בשל האקלים החמים והמים הצלולים המקיפים אותו.',
  sections: [
    {
      title: 'דרכי הגעה לאי פוקוק',
      type: 'list',
      content: [
        {
          subtitle: 'בטיסה',
          text: "שדה התעופה הבינלאומי של פוקוק (Phu Quoc International Airport) מקבל טיסות ישירות מהאנוי, הו צ'י מין סיטי, וכן ממדינות שכנות כמו תאילנד, סינגפור וקמבודיה.",
        },
        {
          subtitle: 'במעבורת',
          text: 'קיימות מעבורות היוצאות מהיבשת הווייטנאמית, בעיקר מנמל הונג דאט (Hà Tiên) ונמל רץ זיה (Rạch Giá), נסיעה שאורכת כשעה וחצי עד שעתיים.',
        },
      ],
    },
    {
      title: 'מבנה האי ופני השטח',
      type: 'text',
      content:
        'פוקוק משתרע על פני כ-574 קמ"ר, מה שהופך אותו לאי הגדול ביותר בוייטנאם. הוא מאופיין ברצועות חוף ארוכות, גבעות מתונות, יערות טרופיים עשירים ואגמים טבעיים. החלק המרכזי והדרומי של האי מפותח יותר מבחינה תיירותית, בעוד שהצפון נותר ברובו אזור טבעי מוגן.',
    },
    {
      title: 'ייחודיות האי',
      type: 'text',
      content:
        'מעבר לנופים עוצרי נשימה, פוקוק ידוע גם בתעשיית הפנינים שלו, ברוטב הדגים המסורתי (nước mắm) המיוצר כאן ונחשב לאחד האיכותיים בעולם וכן בחוות פלפל שחור מהמפורסמות בוייטנאם. האי מציע שילוב מרתק בין טבע לאורבניות מתפתחת, עם מלונות יוקרה לצד כפרי דייגים מסורתיים.',
    },
    {
      title: 'חופים מרהיבים',
      type: 'list',
      content: [
        {
          subtitle: 'חוף סאו (Bãi Sao)',
          text: 'חוף זה מפורסם בזכות החול הלבן הרך והמים הצלולים בגווני כחול-טורקיז.',
        },
        {
          subtitle: "חוף לונג ביץ' (Long Beach)",
          text: 'אחד החופים המרכזיים, מלא במלונות, מסעדות וברים עם אווירה חיה.',
        },
        {
          subtitle: 'חוף Ông Lang',
          text: 'חוף שקט ורומנטי, מושלם לצפייה בשקיעה מרהיבה.',
        },
      ],
    },
    {
      title: 'חוף Ông Lang בזמן שקיעה',
      type: 'image',
      content: '',
      imageUrl: '/images/vietnam/phu-quoc/beach_sunset.jpeg',
    },
    {
      title: 'הפארק הלאומי פוקוק',
      type: 'text',
      content:
        'הפארק משתרע על כ-50% משטח האי והוא בית גידול למגוון רחב של בעלי חיים וצמחים. זהו יעד מושלם לחובבי טבע וטיולים רגליים.',
    },
    {
      title: 'כפרי דייגים מסורתיים',
      type: 'list',
      content: [
        {
          subtitle: 'כפר הדייגים חאם נין (Hàm Ninh)',
          text: 'כפר מסורתי שבו ניתן לראות את חיי הדייגים המקומיים וליהנות ממאכלי ים טריים.',
        },
        {
          subtitle: 'כפר רך ואם (Rạch Vẹm)',
          text: 'כפר קטן ומיוחד הידוע בכוכבי הים הרבים הנמצאים במים הרדודים שלו.',
        },
      ],
    },
    {
      title: 'הכפר האירופאי בדרום האי',
      type: 'text',
      content:
        'באזור הדרומי של האי נבנה כפר מדהים המעוצב בסגנון אירופאי – Sun World Hon Thom Nature Park. הכפר משלב בניינים צבעוניים בסגנון ים-תיכוני, רחובות מרוצפי אבן, מסעדות ובתי קפה שמזכירים עיירות באיטליה או ספרד. האזור נחשב לאחד היפים והציוריים באי ומספק חוויה ייחודית למבקרים.',
    },
    {
      title: 'פארק המים אקווה טופיה (Aquatopia Water Park)',
      type: 'text',
      content:
        'פארק מים זה ממוקם באי הון תום (Hon Thom) שמדרום לפוקוק ומגיעים אליו באמצעות הרכבל של פוקוק, שנחשב לארוך ביותר בעולם. הפארק מציע מגוון מגלשות מים, מתקנים למשפחות, בריכות גלים ועוד, והוא אידיאלי לבילוי יום מלא בכיף והרפתקאות.',
    },
    {
      title: 'אטרקציות נוספות',
      type: 'list',
      content: [
        {
          subtitle: 'Cable Car Phú Quốc',
          text: 'הרכבל הארוך בעולם המחבר בין האי לאיים קטנים נוספים בסביבה ומציע נוף עוצר נשימה.',
        },
        {
          subtitle: 'VinWonders Phú Quốc',
          text: 'פארק שעשועים גדול בצפון האי, המתאים למשפחות עם מתקנים, מופעים ואטרקציות.',
        },
        {
          subtitle: 'Vinpearl Safari',
          text: 'גן חיות ספארי ייחודי בצפון האי, עם בעלי חיים אקזוטיים מכל העולם.',
        },
        {
          subtitle: '"ונציה הקטנה" (Grand World Phú Quốc)',
          text: 'אזור נופש ייחודי המציע תעלות מים בסגנון ונציאני, מופעים ליליים, חנויות, מסעדות ואווירה קסומה.',
        },
        {
          subtitle: 'מוזיאון הדובונים של פוקוק (Teddy Bear Museum)',
          text: 'אתר חווייתי שמתאים במיוחד למשפחות וילדים.',
        },
        {
          subtitle: 'שוק הלילה דינקאו (Dinh Cau Night Market)',
          text: 'מקום מצוין לטעום מאכלים מקומיים, לרכוש מזכרות וליהנות מהאווירה.',
        },
        {
          subtitle: 'האי My Rut Trong Island',
          text: 'אי קטן ואקזוטי להפליא דרומית לפוקוק, עם חוף מהמם, מסעדה ופעילויות ספורט ימי שניתן להגיע אליו לבילוי יומי.',
        },
      ],
    },
    {
      title: 'מתי לבקר בפוקוק?',
      type: 'text',
      content:
        'התקופה האידיאלית לבקר באי היא בין נובמבר לאפריל, כאשר מזג האוויר יבש ונעים. בעונה הגשומה (מאי-אוקטובר) ניתן עדיין לבקר, אך יש לקחת בחשבון גשמים עזים לפרקים.',
    },
    {
      title: 'אפשרויות לינה',
      type: 'list',
      content: [
        {
          subtitle: 'מלונות יוקרה',
          text: 'JW Marriott Phu Quoc, InterContinental Phu Quoc, Fusion Resort Phu Quoc',
        },
        {
          subtitle: 'ריזורטים ברמת ביניים',
          text: 'Salinda Resort, Cassia Cottage',
        },
        {
          subtitle: 'גסטהאוסים ובתי הארחה זולים',
          text: '9Station Hostel, The Fish Hostel',
        },
      ],
    },
    {
      title: 'רשת האוטובוסים החשמליים החינמית',
      type: 'text',
      content:
        'פוקוק מציעה מערכת תחבורה ציבורית חינמית עם אוטובוסים חשמליים, המאפשרים למבקרים להתנייד בין האטרקציות המרכזיות של האי בצורה נוחה וידידותית לסביבה. הרשת מקשרת בין שדה התעופה, חופי האי, אזורי הקניות, והאתרים התיירותיים העיקריים.',
    },
    {
      title: 'סיכום',
      type: 'text',
      content:
        'בשורה התחתונה, האי פוקוק מציע שילוב מופלא של טבע פראי, חופים עוצרי נשימה, תרבות מקומית ואטרקציות מודרניות. בין אם אתם מחפשים חופשת בטן-גב, טיולים בטבע או חוויה קולינרית אותנטית – פוקוק הינו היעד המושלם עבורכם.',
    },
  ],
};
